import Vue from 'vue'
import VueRouter from 'vue-router'

import defaults from '@/modules/default'
import store from '@/store'

import Home from '../views/Home.vue'

import Header from '@/templates/main/Header'
import Footer from '@/templates/main/Footer'

/*

  "Apressa-te, ó Deus, em me livrar; SENHOR, apressa-te em ajudar-me.
  Fiquem envergonhados e confundidos os que procuram a minha alma; voltem para trás e confundam-se os que me desejam mal.
  Virem as costas como recompensa da sua vergonha os que dizem: Ah! Ah!
  Folguem e alegrem-se em ti todos os que te buscam; e aqueles que amam a tua salvação digam continuamente: Engrandecido seja Deus.
  Eu, porém, estou aflito e necessitado; apressa-te por mim, ó Deus. Tu és o meu auxílio e o meu libertador; Senhor, não te detenhas."
  Salmos 70:1-5

*/

Vue.use(VueRouter)

const lang = defaults.language
const permissions = store.getters.userPermissions

const routes = [
  {
    path: `/${lang.meta.pages.home.path}`,
    name: 'home',
    components: {
      default: Home,
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.home.title,
    meta: lang.meta.pages.home
  },
  {
    path: `/${lang.meta.pages.scheduler.path}`,
    name: 'scheduler',
    components: {
      default: () => import(/* webpackChunkName: "Orders" */ '../views/Scheduler.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.scheduler.title,
    meta: lang.meta.pages.scheduler,
    children: [
      {
        path: lang.meta.pages.actions.new,
        name: 'scheduler:new',
        meta: lang.meta.pages.scheduler
      },
      {
        path: ':id',
        props: true,
        name: 'scheduler:view',
        meta: lang.meta.pages.scheduler
      },
      {
        path: `:id/${lang.meta.pages.actions.edit}`,
        props: true,
        name: 'scheduler:edit',
        meta: lang.meta.pages.scheduler
      }
    ]
  },
  {
    path: `/${lang.meta.pages.orders.path}`,
    name: 'orders',
    components: {
      default: () => import(/* webpackChunkName: "Orders" */ '../views/Orders.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.orders.title,
    meta: lang.meta.pages.orders,
    children: [
      {
        props: true,
        path: lang.meta.pages.actions.new,
        name: 'orders:new',
        meta: lang.meta.pages.orders
      },
      {
        path: ':id',
        props: true,
        name: 'orders:view',
        meta: lang.meta.pages.orders
      },
      {
        path: `:id/${lang.meta.pages.actions.edit}`,
        props: true,
        name: 'orders:edit',
        meta: lang.meta.pages.orders
      },
      {
        path: `:id/${lang.meta.pages.actions.repeat}`,
        props: true,
        name: 'orders:repeat',
        meta: lang.meta.pages.orders
      }
    ]
  },
  {
    path: `/${lang.meta.pages.catalog.path}`,
    name: 'catalog',
    components: {
      default: () => import(/* webpackChunkName: "Items" */ '../views/Catalog.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.catalog.title,
    meta: lang.meta.pages.catalog,
    children: [
      {
        path: ':page',
        name: 'catalog:page',
        meta: lang.meta.pages.catalog,
        props: true
      },
      {
        path: `:page/${lang.meta.pages.actions.new}`,
        name: 'catalog:page:new',
        meta: lang.meta.pages.catalog,
        props: true
      },
      {
        path: `:page/:id/${lang.meta.pages.actions.edit}`,
        name: 'catalog:page:edit',
        meta: lang.meta.pages.catalog,
        props: true
      }
    ]
  },
  {
    path: `/${lang.meta.pages.customers.path}`,
    name: 'customers',
    components: {
      default: () => import(/* webpackChunkName: "Customers" */ '../views/Customers.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.customers.title,
    meta: lang.meta.pages.customers,
    children: [
      {
        path: lang.meta.pages.actions.new,
        name: 'customers:new',
        meta: lang.meta.pages.customers
      },
      {
        path: ':id',
        props: true,
        name: 'customers:view',
        meta: lang.meta.pages.customers
      },
      {
        path: ':id/' + lang.meta.pages.actions.edit,
        props: true,
        name: 'customers:edit',
        meta: lang.meta.pages.customers
      }
    ]
  },
  {
    path: `/${lang.meta.pages.historic.path}`,
    name: 'historic',
    components: {
      default: () => import(/* webpackChunkName: "Historic" */ '../views/Historic.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.historic.title,
    meta: lang.meta.pages.historic,
    props: true,
    children: [
      {
        path: ':page',
        props: true,
        name: 'historic:root',
        meta: lang.meta.pages.historic
      },
      {
        path: ':page/:id',
        props: true,
        name: 'historic:root:view',
        meta: lang.meta.pages.historic
      },
      {
        path: `:page/${lang.meta.pages.actions.new}`,
        name: 'historic:root:new',
        meta: lang.meta.pages.historic
      },
      {
        path: `:page/:id/${lang.meta.pages.actions.edit}`,
        props: true,
        name: 'historic:root:edit',
        meta: lang.meta.pages.historic
      }
    ]
  },
  {
    path: `/${lang.meta.pages.financial.path}`,
    name: 'financial',
    components: {
      default: () => import(/* webpackChunkName: "Items" */ '../views/Financial.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.financial.title,
    meta: lang.meta.pages.financial,
    children: [
      {
        path: ':page',
        props: true,
        name: 'financial:page',
        meta: lang.meta.pages.financial
      },
      {
        path: `:page/:id`,
        props: true,
        name: 'financial:page:view',
        meta: lang.meta.pages.financial
      },
      {
        path: `:page/${lang.meta.pages.actions.new}`,
        name: 'financial:page:new',
        meta: lang.meta.pages.financial
      },
      {
        path: `:page/:id/${lang.meta.pages.actions.edit}`,
        props: true,
        name: 'financial:page:edit',
        meta: lang.meta.pages.financial
      }
    ]
  },
  {
    path: `/${lang.meta.pages.users.path}`,
    name: 'users',
    components: {
      default: () => import(/* webpackChunkName: "Users" */ '../views/Users.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.users.title,
    meta: lang.meta.pages.users,
    props: true,
    children: [
      {
        path: lang.meta.pages.actions.new,
        name: 'users:new',
        meta: lang.meta.pages.users
      },
      {
        path: ':id',
        props: true,
        name: 'users:view',
        meta: lang.meta.pages.users
      },
      {
        path: ':id/' + lang.meta.pages.actions.edit,
        props: true,
        name: 'users:edit',
        meta: lang.meta.pages.users
      }
    ]
  },
  {
    path: `/${lang.meta.pages.config.path}`,
    name: 'config',
    components: {
      default: () => import(/* webpackChunkName: "Config" */ '../views/Config.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.config.title,
    meta: lang.meta.pages.config,
    props: true,
    children: [
      {
        path: ':page',
        props: true,
        name: 'config:page',
        meta: lang.meta.pages.config
      },
      {
        path: `:page/${lang.meta.pages.actions.new}`,
        name: 'config:page:new',
        meta: lang.meta.pages.config
      },
      {
        path: `:page/:id/${lang.meta.pages.actions.edit}`,
        props: true,
        name: 'config:page:edit',
        meta: lang.meta.pages.config
      }
    ]
  },
  {
    path: `/${lang.meta.pages.admin.path}`,
    name: 'admin',
    components: {
      default: () => import(/* webpackChunkName: "Admin" */ '../views/Admin.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.admin.title,
    meta: lang.meta.pages.admin
  },
  /* {
    path: `/${lang.meta.pages.test.path}`,
    name: 'test',
    components: {
      default: () => import(/* webpackChunkName: "Test" */ /*'../views/Test.vue'),
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.test.title,
    meta: lang.meta.pages.test,
    props: true,
    children: [
      {
        path: ':page',
        props: true,
        name: 'test:page',
        meta: lang.meta.pages.test
      },
      {
        path: ':page/:id',
        props: true,
        name: 'test:page:view',
        meta: lang.meta.pages.test
      },
      {
        path: `:page/${lang.meta.pages.actions.new}`,
        name: 'test:page:new',
        meta: lang.meta.pages.test
      },
      {
        path: `:page/:id/${lang.meta.pages.actions.edit}`,
        props: true,
        name: 'test:page:edit',
        meta: lang.meta.pages.test
      }
    ]
  }, */
  {
    path: '*',
    name: 'not-found',
    components: {
      default: Home,
      header: Header,
      footer: Footer
    },
    display: lang.meta.pages.home.title,
    meta: lang.meta.pages.home
  }
]

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  var nextPage = to.name
  var permNp = permissions[nextPage]
  if (permNp !== false) {
    next()
  } else if (nextPage !== 'home') {
    router.push('/')
  }
})

export default router
